<template>
     <div>
          <template v-if="snackbars.length >=1">
               <v-snackbar
                    elevation-10
                    fixed
                    :location="(snack.location) ? snack.location : 'top right'"
                    v-for="(snack, n) in snackbars"
                    :key="snack.type"
                    v-model="snack.visible"
                    :color="snack.type"
                    :style="'top: '+(n*70)+'px'"
                    :timeout="snack.timeout"
                    @update:model-value="removeSnackbar(n)"
               >
                    <div v-if="snack.message" v-html="snack.message" class="font-weight-bold"></div>
                    <div v-if="snack.text" v-html="snack.text"></div>
                    <div v-if="snack.errors">
                         <ul class="px-3">
                              <li v-for="(error,field) in snack.errors" :key="field">
                                   <strong v-if="!isType('number',field)">{{ field }}:</strong>
                                   <span v-if="isType('string',field)">
                                      {{ error }}
                                   </span>
                                   <span v-if="isType('object',error)">
                                      <span>
                                        <li v-for="(er, prop) in error" :key="er">
                                             <b>{{prop}}:</b> {{ er }}
                                        </li>
                                      </span>
                                   </span>
                              </li>
                         </ul>
                    </div>

               
                    <template v-slot:actions>
                         <v-btn
                              v-if="!snack.action"
                              color="light"
                              icon="mdi-close"
                              @click="removeSnackbar(n)"
                         >
                         </v-btn>
                         <v-btn
                              v-if="isType('object',snack.action)"
                              :to="snack.action"
                              color="light"
                              icon="mdi-arrow-right"
                         >
                         </v-btn>
                         <v-btn
                              v-if="isType('string', snack.action)"
                              :href="snack.action"
                              target="_blank"
                              color="light"
                              :icon="(snack.actionIcon) ? snack.actionIcon :'mdi-arrow-right'"
                         >
                         </v-btn>
                    </template>
               </v-snackbar>
          </template>
     </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
     computed: {
          ...mapGetters({
                snackbars: 'snackBars/snackbars',
          }),
     },
     methods:{
          removeSnackbar(n){
               this.snackbars.splice(n,1) 
          },
          isNumber(value) {
               return typeof value === 'number';
          },
          isType(type, value) {
               return typeof value === type;
          }
     }
}
</script>